import { PermissionsKey } from '@vedalib/crud'

import { usePermissions } from 'services/Permission/PermissionContext'

export const useContentPlus = () => usePermissions(PermissionsKey.project_pages_content_plus)
